export const retireServiceWorkers = async ({ serviceWorker, cacheStorage }) => {
	const results = { registrations: 0, caches: 0 }

	if (serviceWorker?.getRegistrations) {
		const registrations = await serviceWorker.getRegistrations()
		const unregistered = await Promise.all(
			registrations.map((registration) => registration.unregister()),
		)
		results.registrations = unregistered.filter(Boolean).length
	}

	if (cacheStorage?.keys && cacheStorage?.delete) {
		const keys = await cacheStorage.keys()
		const deleted = await Promise.all(keys.map((key) => cacheStorage.delete(key)))
		results.caches = deleted.filter(Boolean).length
	}

	return results
}
